import { render, staticRenderFns } from "./SiteInicio.vue?vue&type=template&id=bd3d78f2&"
import script from "./SiteInicio.vue?vue&type=script&lang=js&"
export * from "./SiteInicio.vue?vue&type=script&lang=js&"
import style0 from "./SiteInicio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports